module.exports = __webpack_public_path__ + "media/images/lb/882-e27487b8fdccd79a21353bd9e0f210db.svg";